export default __webpack_public_path__ + "static/media/feedback.9c2f57d7.svg";